import React from "react";
import _ from "lodash";

import WarningTooltip from "../../../components/WarningTooltip";
import {PrimaryButton} from "../../../components/Buttons";
import {CONFIRMATION_STATE} from "../constants";


export const useStepSkipping = (currService, setLoading, syncOnboardingData, updateState, handleError, guardUnsaved) => {
  const handleSkipClick = guardUnsaved(async () => {
    try {
      setLoading(true);
      syncOnboardingData(await currService.skipStep());
      await updateState(true);
      setLoading(false);
    } catch (error) {
      handleError(error);
    }
  })

  const skipBtn = (
    <PrimaryButton
      text={<>
        Überspringen & weiter<WarningTooltip title={'Sie können diesen Schritt überspringen und später zurückkehren. Fehlende Pflichtfelder werden markiert. Sind alle Angaben vollständig, bestätigen Sie den Schritt später mit “Speichern & weiter“.'} />
      </>}
      variant={"outlined"}
      onButtonClick={handleSkipClick}
    />
  )

  return {
    handleSkipClick,
    skipBtn,
  }
}